import {
  enableProdMode,
  inject,
  runInInjectionContext,
} from '@angular/core';
import {
  platformBrowserDynamic,
} from '@angular/platform-browser-dynamic';
import {
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  FunctionalContentOverrideActionHandler,
} from '@refx/shared-services';
import {
  AppModule,
} from './app/app.module';
import {
  environment,
} from './environments/index';

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () =>
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((m) => {
      runInInjectionContext(m.injector, () => {
        const rulesEngineRunnerService = inject(RulesEngineRunnerService);
        rulesEngineRunnerService.actionHandlers.add(inject(FunctionalContentOverrideActionHandler));
      });
    })
);
